/**
 * Feature flags — flip a value to show/hide a part of the site.
 * Set `projects` to true when you want the "Cool projects & clients" section back.
 */
export const featureFlags = {
  projects: false,
};
